import React from "react";
import { Grid, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import "../assets/css/header.css";
import "../assets/css/icon.css";
import { actions, logout, service } from "../model";
import { useDispatch, useSelector } from "react-redux";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const reduxObject = useSelector((state) => state.user?.redux_object);
  const token = reduxObject.accessToken;

  const handleLogout = async () => {
    dispatch(actions.logout());
  };

  return (
    <Grid
      container
      className="bg-blue-dark"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "5px 0px",
        alignItems: "center",
        height: "90px",
      }}
    >
      {/* icona logout/back */}
      <Grid
        item
        xs={2}
        md={0.5}
        style={{
          display: "flex",
          justifyContent: "start",
          marginLeft: "0px",
        }}
      >
        <div
          onClick={handleLogout}
          className="icon-logout container-icon"
          aria-label="Logout"
          style={{ cursor: "pointer" }}
        ></div>
      </Grid>

      {/* titolo */}
      <Grid
        item
        xs={8}
        md={10.5}
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Typography className="color-light title-header">
          Andamentale
        </Typography>
      </Grid>

      {/* logo */}
      <Grid
        item
        xs={2}
        md={0.5}
        style={{
          display: "flex",
          justifyContent: "end",
        }}
      >
        <div className="logo-lexia-header" />
      </Grid>
    </Grid>
  );
};

export default Header;
